// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._64oboBqe{bottom:0;display:flex;justify-content:center;left:0;padding:max(.5rem,min(.83vw,1rem));position:fixed;width:100%;z-index:3}.q-6X-Pia{align-items:center;background-color:var(--color-bg);border-radius:1.5rem;box-shadow:0 .5rem 1rem rgba(0,0,0,.1);display:flex;font-size:.88rem;gap:1rem;justify-content:space-between;line-height:1.4;padding:1rem}.q-6X-Pia a{color:var(--color-primary)}@media(hover:hover){.q-6X-Pia a:hover{-webkit-text-decoration:underline;text-decoration:underline}}@media(hover:none){.q-6X-Pia a:active{-webkit-text-decoration:underline;text-decoration:underline}}.q-6X-Pia .HpSVrPqw{font-size:max(.75rem,min(.73vw,.88rem));min-width:0;min-width:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"wrapper": "_64oboBqe",
	"container": "q-6X-Pia",
	"btn": "HpSVrPqw"
};
module.exports = ___CSS_LOADER_EXPORT___;
